module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9608.f77c9766.jpg";